export enum PersonalSettingsSegment {
    USER = 'user',
    ME = 'me',
    SETTINGS = 'settings',
}
